<template>
  <Dialog v-model:visible="showDialog" :modal="true" :header="model
    ? $t('ItemCategory.StoreCategoryMapping.EditFormheader')
    : $t('ItemCategory.StoreCategoryMapping.Formheader')
    " :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :style="{ width: '45vw' }" @after-hide="IsClear"
    :closable="false">
    <template #header>
      <b-container fluid>
        <b-row>
          <b-col lg="6" md="6">
            <h3 class="compo-heading ps-0">{{ model ? $t('ItemCategory.StoreCategoryMapping.EditFormheader') :
              $t('ItemCategory.StoreCategoryMapping.Formheader') }}</h3>
          </b-col>
          <b-col lg="6" md="6" class="d-flex flex-row-reverse">
            <Button icon="pi pi-times" class="p-button-rounded p-button-text"
              @click="ModelStore ? onCloseClick() : IsClear()" />
          </b-col>
        </b-row>
      </b-container>
    </template>
    <b-container fluid>
      <b-form @submit.prevent="AddMapping">
        <b-row>
          <b-col lg="8" md="8" sm="12" cols="12">
            <div class="field">
              <StoreDropDown :label="$t('5007.storename')" id="Storename" name="Storename" :rules="{ required: false }"
                :required-icon="true" v-model="ModelStore" :disabled="IsDisabled"
                @update:model-value="SelectStore(ModelStore)" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="8" md="8" sm="12" cols="12" class="addcircle_field">
            <div class="field">
              <CustomDropdown id="Item category" name="Item category" :label="$t('5007.category')"
                :rules="{ required: false }" :required-icon="true" :items="Categoryoption"
                v-model="itemCategoryIddata" />
            </div>
            <span class="add_circle" @click="FunctionRights(EntityIds.Category, 'Category')"><i
                class="pi pi-plus"></i></span>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col class="d-flex flex-row-reverse">
            <AddButton btnname="Add" @click="AddMapping" />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="storecatmappingteble">
            <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
              :columns="ReOrderheaders" v-model:value="AddData" :seriaNlumber="true">
              <template v-slot:action="{ data }">
                <span>
                  <Button icon="pi pi-trash" class="p-button-rounded p-button-text deleteicon"
                    @click="Deletedata(data)" />
                </span>
              </template>
            </Tableview>
          </b-col>
        </b-row>

        <b-row v-if="AddData.length != 0">
          <b-col>
            <Footer @cancel="(showDialog = false), IsClear()" :cancelhide="false" :label="label" @click="IsSubmit"
              :loading="Saveloader" />
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </Dialog>
  <CategoryCreation v-if="DialogShow.Category" @load="getitemcategory(), (DialogShow.Category = false)"
    @close="DialogShow.Category = false" :OperationID="ObjOperationId" :EntityId="EntityIds.Category" />
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :selectedcontent="selectedcontent" :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <ConfirmDialog></ConfirmDialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, defineAsyncComponent } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import GenericService from "../../../../Service/GenericMasterService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";
import AddButton from "../../../../../../components/GeneralButtons/AddButton.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import MultiselectDropdown from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";

import Storeservice from "../../../../Service/StoreService";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import ItemCategoryservice from "../../../../Service/CategoryService";
import moment from "moment";
import CategoryCreation from "../../../Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import { useRoute } from "vue-router";
import { useConfirm } from "primevue/useconfirm";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },
  components: {
    MultiselectDropdown,

    Footer,
    TextField,
    Textarea,
    createdsuccessfully,
    UpdatedSuccessfully,
    AlreadyExist,
    CustomDropdown,
    CategoryCreation,
    Tableview,
    StoreDropDown,
    ConfirmDialog: defineAsyncComponent(() => import('primevue/confirmdialog')),
  },
  setup(props, { emit }) {
    //Session Hospital&Branch ID
    const routes = useRoute();
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let IsEditFlag = ref(false);
    let BranchId = ref(0);
    let UserId = Number(session.UserId);
    const showDialog = ref(false);
    let storestatus = ref(true);
    let Entitydata = ref();
    let loading = ref(false);
    let Saveloader = ref(false);
    const ReOrderData: any = ref([]);
    let AddData: any = ref([]);
    let CopyAddData: any = ref([]);
    const IsDisabled = ref(false);
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    let storeId = routes.query.Id ?? 0;
    let StoreBranchmapid = routes.query.storebranchmapid ?? 0;
    let Searchtablevalue = ref("");

    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Category: false,
    });
    let EntityIds = ref({
      Category: 106,
    });
    debugger;
    const NoItemsMapped = ref("");
    const model: any = ref(props.selectedItem);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    if (model.value != null) {
      IsEdit();
      storestatus.value = true;
    } else {
      IsCreate();
      storestatus.value = false;
    }
    const Categoryoption = ref();
    const successpop = ref(false);
    const Editmodel = ref(false);
    const updatepop = ref(false);
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const alreadyexistpop = ref(false);
    const toast = useToast();
    const confirm = useConfirm();
    let isSubmitCalled = false;
    let itemCategoryIddata = ref();
    let diffArray1: any = [];
    let actioneEdit = ref(false);
    let mapformdata = ref({
      // IsNew: true,
      // IsModified: true,
      // IsDeleted: true,
      // IsActive: true,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      StoreId: ref(),
      ItemCategoryId: ref([]),
      EntityId: 0,
      EntityOperationId: 0,
      StoreName: "",
      ItemCategoryName: "",
      StoreBranchMapId: 0,
    });

    const ReOrderheaders = [
      {
        header: t(
          "storetabdetails.StoreCategoryMappingCreationTable.StoreName"
        ),
        field: "StoreName",
      },
      {
        header: t(
          "storetabdetails.StoreCategoryMappingCreationTable.ItemCategory"
        ),
        field: "ItemCategoryName",
      },
      {
        field: "action",
        header: "Actions",
        slot: "action",
        fieldDisplay: "false",
      },
    ];

    const copydataModel = JSON.parse(JSON.stringify(mapformdata.value));

    //Add-New Button-Open Popup
    function IsCreate() {
      showDialog.value = true;
    }

    // get item category

    watch(AddData, (newValue) => {
      getitemcategory();
    });

    async function getitemcategory() {
      debugger;
      try {
        const dataresponse = await ItemCategoryservice.getdata();
        if (AddData.value.length != 0) {
          Categoryoption.value = dataresponse["result"]
            .filter(
              (i1) =>
                i1.Status == true &&
                i1.HospitalId == HospitalId &&
                check(i1) != true
            )
            .map((item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            });
        } else {
          Categoryoption.value = dataresponse["result"]
            .filter((i1) => i1.Status == true && i1.HospitalId == HospitalId)
            .map((item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            });
        }
      } catch (error) {
        console.log(error);
      }
    }

    //Save

    function check(i: Number) {
      for (let j = 0; j < AddData.value.length; j++) {
        if (AddData.value[j].ItemCategoryId == i["Id"]) {
          return true;
        }
      }
    }
    let selectedcontent = ref("Name Already Exist")
    async function IsSubmit() {
      debugger;
      emit("loadershow");
      Saveloader.value = true;
      mapformdata.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      mapformdata.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      mapformdata.value.BranchId = BranchId.value
        ? BranchId.value
        : Number(routes.query.BranchId);
      mapformdata.value.HospitalId = HospitalId;
      mapformdata.value.ModifiedBy = UserId;
      mapformdata.value.CreatedBy = UserId;
      mapformdata.value.EntityId = Number(Entitydata.value.EntityId);
      let objinsert = Object.assign(mapformdata.value);
      console.log(objinsert);
      try {
        let msg = "";
        let data_response: any = "";
        const length = AddData.value.length;

        for (let index = 0; index < length; index++) {
          mapformdata.value.ItemCategoryId =
            AddData.value[index].ItemCategoryId;
          mapformdata.value.StoreId = AddData.value[index].StoreId;
          data_response = await ItemStoreMappingService.create(objinsert);
          msg = data_response["ErrorInfo"].ErrorCode;
        }

        console.log(data_response);
        emit("loaderhide");
        if (data_response["result"] == "false" && msg == null) {
          Saveloader.value = false;
          alreadyexistpop.value = true;
        } else if (msg == null) {
          let arr1: any = AddData.value.map((item) => item.ItemCategoryId);
          debugger;
          let delMap = diffArray1.filter((value) => !arr1.includes(value));
          let data_response1: any;
          if (delMap.length > 0) {
            for (let j = 0; j < delMap.length; j++) {
              mapformdata.value.ItemCategoryId = delMap[j];
              data_response1 = await ItemStoreMappingService.update(objinsert);
            }
            if (data_response1["result"] == "False" && msg == null) {
              Saveloader.value = false;
              alreadyexistpop.value = true;
            }
            else if (data_response1["result"] != "False" && data_response1["result"] != "True" && msg == null) {
              Saveloader.value = false
              selectedcontent.value = data_response1["result"]
              alreadyexistpop.value = true;
              getitemcategory()
            }
            else if (msg == null) {
              Saveloader.value = false;
              updatepop.value = true;
            }
          } else {
            if (storestatus.value) {
              Saveloader.value = false;
              updatepop.value = true;
            } else {
              Saveloader.value = false;
              successpop.value = true;
            }
          }
        }
      } catch (error) {
        emit("loaderhide");
        alert(error);
        Saveloader.value = false;
      }
      debugger;
    }

    //Get Value from Table and show in Popup

    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      try {
        label.value = t("btn.update");
        let Id = model.value.StoreId;
        BranchId.value = model.value.BranchId;
        let response = await ItemStoreMappingService.StoreCategoryMappingget(
          Id,
          BranchId.value
        );
        debugger;
        let datas = response["result"];
        mapformdata.value.StoreId = Number(datas[0]["StoreId"]);
        mapformdata.value.StoreBranchMapId = Number(
          datas[0]["StoreBranchMapId"]
        );

        ModelStore.value = Number(datas[0]["StoreBranchMapId"]);

        if (ModelStore.value) {
          IsEditFlag.value = true;
        }

        mapformdata.value.StoreName = datas[0]["StoreName"];

        diffArray1 = datas.map((item) => item.CategoryId);
        AddData.value = [];
        datas.forEach((item) => {
          AddData.value.push({
            StoreId: item.StoreId,
            ItemCategoryId: item.CategoryId,
            StoreName: item.StoreName,
            ItemCategoryName: item.CategoryName,
          });
        });
        CopyAddData.value = AddData.value;
        console.log(CopyAddData.value);
        IsDisabled.value = true;
        debugger;
        console.log(Categoryoption.value);
        emit("loaderhide");
        Editmodel.value = false;
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    }

    onMounted(() => {
      debugger;
      if (storeId != 0) {
        ModelStore.value = Number(StoreBranchmapid);

        IsDisabled.value = true;
      }
      document.addEventListener("keydown", onKeyUp);
      // getstore();
      getitemcategory();
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    //Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    //Clear Values while clicking Add New Button
    const IsClear = () => {
      Object.assign(mapformdata.value, copydataModel);
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    };
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const AddMapping = handleSubmit(async (values) => {
      debugger;
      const val = mapformdata.value.StoreId;
      const val1 = itemCategoryIddata.value;

      if (!val || !val1) {
        toast.add({
          severity: "warn",
          summary: "Please select both store and category",
          life: 3000
        });
        return;
      }

      const ItemCatList = Categoryoption.value.find((i1) => i1.Id == val1);
      const categoryExists = AddData.value.some(
        (item) => item.ItemCategoryId === val1
      );

      if (categoryExists) {
        alreadyexistpop.value = true;
        itemCategoryIddata.value = "";
        return;
      }

      let data1 = {};
      data1["StoreId"] = val;
      data1["StoreName"] = mapformdata.value.StoreName;
      data1["ItemCategoryId"] = val1;
      data1["ItemCategoryName"] = ItemCatList.Name;
      AddData.value.push(data1);
      console.log(AddData.value);
      CopyAddData.value = AddData.value;
      console.log(CopyAddData.value);

      itemCategoryIddata.value = "";
      IsDisabled.value = true;
      getitemcategory();

      toast.add({
        severity: "success",
        summary: "Successful",
        detail: "The category has been added successfully.",
        life: 3000
      });
      return;
      // resetForm();
    });

    function Deletedata(data) {
      debugger;
      if (IsEditFlag.value) {
        if (AddData.value.length > 1) {
          const index = AddData.value.indexOf(data);
          if (index !== -1) {
            AddData.value.splice(index, 1);
          }
          getitemcategory();
          if (AddData.value.length === 0) {
            IsDisabled.value = false; // Set IsDisabled to false
          }

          toast.add({
            severity: "success",
            summary: "Item Deleted",
            detail: "The item has been deleted successfully.",
            life: 3000,
          });
          return;
        } else {
          toast.add({
            severity: "info",
            summary: "Cannot Delete Last Item",
            detail: "You cannot delete the last remaining item in edit mode. Please delete the record in list view for the respective store.",
            life: 5000,
          });
          return;
        }
      } else {
        const index = AddData.value.indexOf(data);
        if (index !== -1) {
          AddData.value.splice(index, 1);
        }
        getitemcategory();
        if (AddData.value.length === 0) {
          IsDisabled.value = false; // Set IsDisabled to false
        }

        toast.add({
          severity: "success",
          summary: "Item Deleted",
          detail: "The item has been deleted successfully.",
          life: 3000,
        });
        return;
      }
    }

    let ModelStore: any = ref();
    async function SelectStore(value) {
      debugger;
      if (value) {
        let response = await ItemStoreMappingService.StoreCategoryMappingget(
          value.Id ? value.Id : Number(routes.query.Id),
          value.BranchId ? value.BranchId : Number(routes.query.BranchId)
        );
        let datas = response["result"];
        AddData.value = [];
        datas.forEach((item) => {
          AddData.value.push({
            StoreId: item.StoreId,
            ItemCategoryId: item.CategoryId,
            StoreName: item.StoreName,
            ItemCategoryName: item.CategoryName,
          });
        });
        diffArray1 = datas.map((item) => item.CategoryId);

        if (AddData.value.length == 0 && IsDisabled.value == false) {
          toast.add({
            severity: "warn",
            summary: "No categories mapped with this store.",
            detail: "",
            life: 3000,
          });
        }
        else {
          IsEditFlag.value = true;
        }

        BranchId.value = value.BranchId;
      }

      debugger;
      if (value?.Id) {
        mapformdata.value.StoreName = value.Name;
        mapformdata.value.StoreBranchMapId = value.StoreBranchMapId;
        mapformdata.value.StoreId = value.Id;
      } else {
        mapformdata.value.StoreName = String(routes.query?.storename);
        mapformdata.value.StoreBranchMapId = Number(
          routes.query.storebranchmapid
        );
        mapformdata.value.StoreId = routes.query.Id;
      }
    }

    function onCloseClick() {
      debugger;
      confirm.require({
        message: 'You have unsaved changes. Are you sure you want to close without saving?',
        header: 'Unsaved Changes',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined p-button-sm rounded',
        acceptClass: 'p-button-info p-button-sm rounded',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        // Using default button styles
        accept: () => {
          // showDialog.value = false;
          IsClear();
        },
        reject: () => {
          // User clicked No
          showDialog.value = true;
        }
      });
    }

    const SearchCategory = (item) => {
      debugger;
      if (item) {
        console.log(CopyAddData.value);

        AddData.value = CopyAddData.value.filter((i) =>
          i.ItemCategoryName.toLowerCase().includes(item.toLowerCase())
        );
        console.log(CopyAddData.value);
      } else {
        AddData.value = CopyAddData.value;
      }
    };

    return {
      Saveloader,
      model,
      ObjOperationId,
      FunctionRights,
      EntityIds,
      DialogShow,
      label,
      itemCategoryIddata,
      status: storestatus.value,
      // Storenamelist,
      Categoryoption,
      getitemcategory,
      mapformdata,
      successpop,
      IsClear,
      IsEdit,
      IsCreate,
      showDialog,
      Editmodel,
      closetrigger,
      errors,
      IsSubmit,
      updatepop,
      alreadyclosetrigger,
      alreadyexistpop,
      loading,
      ReOrderData,
      ReOrderheaders,
      AddMapping,
      AddData,
      IsDisabled,
      Deletedata,
      SelectStore,
      ModelStore,
      storeId,
      NoItemsMapped,
      Searchtablevalue,
      SearchCategory,
      BranchId,
      selectedcontent,
      onCloseClick
    };
  },
});
</script>

<style lang="scss">
.storecatmappingteble .p-datatable .p-datatable-footer {
  padding: 0 !important;
}
</style>
